import { createAction } from 'redux-actions';
import { INVOICE_SEARCH_SELECT } from '../../constants/actionTypes/invoiceActionTypes';

export const selectInvoice = createAction(INVOICE_SEARCH_SELECT);
